import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { LocaleContext } from '../i18n/LocaleContext';
import { locales, defaultLocale } from '../i18n/locales';
import config from '../../config';

const Select = styled('select')`
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff;
  font-size: 13px;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  outline: none;

  &:hover {
    border-color: rgba(255, 255, 255, 0.6);
  }

  option {
    color: #333;
    background: #fff;
  }
`;

const LanguageSelector = ({ location }) => {
  const { locale } = useContext(LocaleContext);
  const currentConfig = locales[locale] || locales[defaultLocale];

  const handleChange = (e) => {
    const targetLocale = e.target.value;
    const targetConfig = locales[targetLocale];
    if (!targetConfig) return;

    let contentPath = location ? location.pathname : '/';

    // Remove pathPrefix if present
    const pathPrefix = config.gatsby.pathPrefix || '';
    if (pathPrefix && contentPath.startsWith(pathPrefix)) {
      contentPath = contentPath.substring(pathPrefix.length) || '/';
    }

    // Strip trailing slash for consistent matching
    if (contentPath.length > 1 && contentPath.endsWith('/')) {
      contentPath = contentPath.slice(0, -1);
    }

    // Strip current locale slug
    if (!currentConfig.isDefault && currentConfig.slug && contentPath.startsWith(`/${currentConfig.slug}`)) {
      contentPath = contentPath.substring(currentConfig.slug.length + 1) || '/';
    }

    // Build target path
    const targetPrefix = targetConfig.isDefault ? '' : `/${targetConfig.slug}`;
    const targetPath = `${pathPrefix}${targetPrefix}${contentPath === '/' ? '/' : contentPath}`;

    window.location.pathname = targetPath;
  };

  return (
    <Select value={locale} onChange={handleChange} aria-label="Select language">
      {Object.entries(locales).map(([code, conf]) => (
        <option key={code} value={code}>{conf.flag} {conf.label}</option>
      ))}
    </Select>
  );
};

export default LanguageSelector;
